import AdvancedSearch from './AdvancedSearch';

export default AdvancedSearch;
